module.exports = __webpack_public_path__ + "media/images/banner/becos/becos-tj-banner_v2-fa53b7b50eccc13a9d6f1e2e7acc94d4.jpg";